<template>
  <div v-if="UTMLink" class="md:block mb-8 bg-coral-100 p-6">
    <div class="flex items-center my-2">
      <svg-vue v-tooltip="trackingLinkText" icon="information-circle" class="h-5" />
      <label for="utm" class="ml-2">Tracking link</label>
    </div>
    <div class="flex space-x-2 items-stretch">
      <input ref="utmLink" v-model="UTMLink" type="text" class="cursor-not-allowed" readonly @click="copyText" />
      <div class="py-1 flex">
        <button class="button" @click="copyText">copy</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { gtmEvent } from '../services/gtm';

export default {
  computed: {
    ...mapGetters('timeline', [
      'UTMLink',
      'hasInstagramDeliverables',
      'hasYoutubeDeliverables',
      'hasTiktokDeliverables',
    ]),
    trackingLinkText() {
      let trackingText = '';

      if (this.hasInstagramDeliverables()) {
        trackingText =
          'This is your personalized tracking link. Please make sure to use it in your bio or Linktree (if you have one). Feel free to shorten it if you feel it would look better in your bio. Why is it important? This helps both you and us see the impact you have on your audience and helps us make informed decisions regarding future opportunities and campaigns catered to you specifically.';
      }

      if (this.hasYoutubeDeliverables()) {
        trackingText =
          'This is your personalized tracking link. Please make sure to use it in the description box. Why is it important? This helps both you and us see the impact you have on your audience and helps us make informed decisions regarding future opportunities and campaigns catered to you specifically.';
      }

      if (this.hasTiktokDeliverables()) {
        trackingText =
          'This is your personalized tracking link. Please make sure to use it in your bio or in a pinned comment on your posts for this campaign. Feel free to shorten it if you feel it would look better. Why is it important? This helps both you and us see the impact you have on your audience and helps us make informed decisions regarding future opportunities and campaigns catered to you specifically.';
      }

      return trackingText;
    },
  },
  methods: {
    copyText() {
      this.$refs.utmLink.select();
      document.execCommand('copy');

      gtmEvent('tracking_link', {
        ga_category: 'campaign',
        ga_action: 'tracking_link',
      });
    },
  },
};
</script>
